export default class About {
    constructor() {
    	this.accordion();
    }

    accordion() {
        const items = document.querySelectorAll('.about article.faq .text-container .item');
        Array.from(items).forEach(item => {
        	item.querySelector('h3').addEventListener('click', function(){
        		this.parentElement.classList.toggle('open');
        	});
        });
    }
}